import React, {useEffect, useState} from 'react';
import IconBtn from "../../../../shared/ui/icon/IconBtn";
import colorUtils from "../../../../shared/colorUtils";
import SelectCustom2 from "../../../../shared/ui/form/select2/Select2";
import {getArrayByNumber} from "../../../../shared/utils/arrayUtils";
import {divisor} from "../../../../shared/utils/forms/useStructureForm";
import {useSelector} from "react-redux";
import {selectPharmacies} from "../../../../core/reducer/auth/authSlice";
import i18n from "../../../../shared/utils/languages/config/i18n";
import FormGroupCustom from "../../../../shared/ui/form/FormGroupCustom";
import {typeHoursInitArray} from "../../../../common/typeHours";
import {selectSelectedPharmacy} from "../../../../core/reducer/pharmacySlice";

const ElementCompanyHours = ({changeValue, dataForm, dataFormatted, initArrayLength = 1, pre = '', setData, errors}: {
    pre?: string
    initArrayLength?: number
    dataForm?: any;
    setData?: any;
    dataFormatted: any;
    errors: any;
    changeValue: (data: any) => void
}) => {
    const selectedPharmacy = useSelector(selectSelectedPharmacy);
    const isTimeBank = !!selectedPharmacy?.timeBank;

    const pharmacies = useSelector(selectPharmacies);
    const [pharmaciesOpt, setPharmaciesOpt] = useState<any[]>([])

    useEffect(() => {
        setPharmaciesOpt((pharmacies || [])?.map(ele => ({label: ele.name, value: ele?.idDocument})))
    }, [pharmacies]);


    const [number, setNumber] = useState(initArrayLength)
    useEffect(() => {
        setNumber(initArrayLength)
    }, [initArrayLength]);
    useEffect(() => {
        dataFormatted.length > number && setNumber(dataFormatted.length)
    }, [dataForm]);
    const addElementHandler = () => {
        if (dataFormatted.length >= number) {
            setNumber(number + 1)
        }
    }
    const removeItemHandler = (index: number) => {
        setNumber(number - 1)
        setData && setData(dataFormatted.filter((ele: any, i: number) => index !== i), pre)
    }

    const columns: { name: string, label: string } [] = [
        {
            label: 'Ore contratto settimanali',
            name: 'weeklyContractHours',
        },
        ...typeHoursInitArray.map(ele => ({
            label: (ele.timeBank && ele.timeBank !== isTimeBank) ? 'Straordinario' : ele.label,
            name: ele.name
        }))
    ]
    return (
        <>
            <div className={'d-flex justify-content-between align-items-baseline pb-2'}>
                Imposta una o più aziende di pertinenza e le ore iniziali a disposizione.

                <div className={'d-flex justify-content-end align-items-center gap-2 mt-2'} onClick={addElementHandler}>
                    <span className={'text-primary pointer'}>Aggiungi Azienda</span>
                    <IconBtn variant={'outline'} icon={'/assets/icons/plus-c.svg'} size={'20px'}
                             disabled={false}
                             clickHandler={addElementHandler} tintColor={colorUtils.theme.primary}></IconBtn>
                </div>
            </div>
            {
                getArrayByNumber(number).map((num, k) => <div
                    className={" form-element-company d-flex flex-column gap-2 mb-4"}>
                    <div className={"d-flex gap-2"}>
                        <IconBtn variant={'outline-danger'} icon={'/assets/icons/trash.svg'} size={'20px'}
                                 clickHandler={() => removeItemHandler(num)}
                                 tintColor={colorUtils.theme.error}></IconBtn>
                        <div className={'w-100'}>
                            <SelectCustom2
                                options={pharmaciesOpt}
                                value={dataForm[`${pre}${divisor}${num}${divisor}pharmacy`]}
                                changeValue={(val: any) =>
                                    changeValue({name: `${pre}${divisor}${num}${divisor}pharmacy`, value: val})
                                }
                                error={errors[`${pre}${divisor}${num}${divisor}pharmacy`]}
                            />
                        </div>
                    </div>
                    <div className={'d-flex w-100'}>
                        <table className={'table-hours-comp'}>
                            <thead>
                            <tr>
                                {columns.map(col => <th style={{maxWidth: '110px'}}>{col.label}</th>)}
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                {columns.map(col => <td style={{maxWidth: '110px'}}>
                                        <FormGroupCustom
                                            key={`${pre}${divisor}${num}${divisor}${col.name}`}
                                            structure={{
                                                name: `${pre}${divisor}${num}${divisor}${col.name}`,
                                                type: 'input',
                                                dataElement: {type: 'text'},
                                                col: {xs: 12},
                                            }}
                                            value={dataForm[`${pre}${divisor}${num}${divisor}${col.name}`] || ''}
                                            isSubmit={true}
                                            dataForm={dataForm}
                                            changeValue={changeValue}
                                            errors={errors}
                                        />
                                    </td>
                                )}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>)
            }

        </>


    );
};

export default ElementCompanyHours;
